import React, { Component, useState, useCallback, useEffect } from "react";
import { Step, Segment, Icon, Modal, Form, Message } from "semantic-ui-react";

import "./New.scss";

import "react-table/react-table.css";

import moment from "moment";
import { Preview } from "../../../components/Campaign/Preview";
import { Segmentation } from "../../../components/Campaign/Segmentation";
import { Surveys } from "../../../components/Campaign/Surveys";
import { SMSNotification } from "../../../components/Campaign/SMSNotification";
import { EmailNotification } from "../../../components/Campaign/EmailNotification";
import { NavLink } from "react-router-dom";
import camelize from "../../../components/utils/camelize";
import { isEqual } from "lodash";
import { ToastProvider, useToasts } from "react-toast-notifications";
import { useAuth } from "../../../AuthenticationStore";

export default class New extends Component {
  campaignService;
  state = {
    cdCampaignConfiguration: null,
    cdEmailNotification: null,
    cdFiltersCampaign: null,
    cdNotificationSurvey: null,
    cdOriginal: null,
    cdPaymentSurvey: null,
    cdSmsNotification: null,
    errors: {},
    errorsPreview: [],
    generalErrors: [],
    idCampaign: undefined,
    informationChange: false,
    loadInitial: false,
    loading: false,
    loadingData: true,
    modalConfirmLauch: false,
    modalSuccess: false,
    modification: true,
    notificationText: undefined,
    showToast: false,
    status: undefined,
    step: 1
  };

  async componentDidMount() {
    // if is edit configuration change idcampaign
    if (this.props.match && this.props.match.params.campaignId) {
      await this.setState({
        idCampaign: this.props.match.params.campaignId
      });
    }

    this.setState({ loadingData: false });
    return;
  }

  loadCampaign() {
    if (!this.state.idCampaign) return;
    // get or create campaign and save in storage
    this.setState({ loading: true });
    let optionConfigurationRequest = this.campaignService.getConfigurationCampaign(
      this.state.idCampaign
    );

    optionConfigurationRequest.then(response => {
      if (!response.result) return;

      this.setState({
        cdCampaignConfiguration: response.object.cdCampaignConfiguration,
        cdEmailNotification: response.object.cdEmailNotification,
        cdFiltersCampaign: JSON.parse(
          JSON.stringify(response.object.cdFiltersCampaign)
        ),
        cdNotificationSurvey: response.object.cdNotificationSurvey,
        cdOriginal: response.object,
        cdPaymentSurvey: response.object.cdPaymentSurvey,
        cdSmsNotification: response.object.cdSmsNotification,
        idCampaign: response.object.campaignId,
        statusCampaign: response.object.status
      });

      // set actual step
      let actualStep = 1;
      if (response.object.status > 1) {
        actualStep = 6;
      } else if (!response.object.cdFiltersCampaign) {
        actualStep = 2;
      } else if (!response.object.cdSmsNotification) {
        actualStep = 3;
      } else if (!response.object.cdEmailNotification) {
        actualStep = 4;
      } else if (
        !!response.object.cdNotificationSurvey ||
        !!response.object.cdPaymentSurvey
      ) {
        actualStep = 5;
      } else {
        // all steps complete
        actualStep = 5;
      }

      this.setState({ step: actualStep });

      if ([2, 4, 5, 6].indexOf(response.object.status) !== -1) {
        this.setState({ modification: false });
      }

      this.setState({ loading: false });
    });
  }

  validationsGeneralData(cdCampaignConfigurationData) {
    let exception, field;

    if (
      !cdCampaignConfigurationData.name ||
      cdCampaignConfigurationData.name === ""
    ) {
      exception = "Debe poner un nombre a la campaña";
      field = "name";
    }

    if (
      !cdCampaignConfigurationData.startDate ||
      cdCampaignConfigurationData.startDate === ""
    ) {
      exception = "Este campo no puede ir vacio";
      field = "startDate";
    }

    if (
      !cdCampaignConfigurationData.finishDate ||
      cdCampaignConfigurationData.finishDate === ""
    ) {
      exception = "Fecha de finalización no valida";
      field = "finishDate";
    }

    if (
      !cdCampaignConfigurationData.dueDay ||
      cdCampaignConfigurationData.dueDay.length <= 0
    ) {
      exception = "Falta seleccionar dias de corte";
      field = "dueDay";
    }

    if (!field) return;

    return {
      errors: [{ exception, field }],
      status: 0
    };
  }

  validationsSegmentation(cdFiltersCampaignData) {
    let exception, field;

    if (
      !cdFiltersCampaignData ||
      (cdFiltersCampaignData && cdFiltersCampaignData.length === 0)
    ) {
      exception = "Debe seleccionar y parametrizar al menos un segmento";
      field = "segmentation";
    }

    if (!field) return;

    return {
      errors: [{ exception, field }],
      status: 0
    };
  }

  validationsSurveys(cdNotificationSurveyData, cdPaymentSurveyData) {
    let exception, field;

    if (
      cdNotificationSurveyData &&
      ((cdNotificationSurveyData.question &&
        !cdNotificationSurveyData.answer) ||
        (cdNotificationSurveyData.question &&
          cdNotificationSurveyData.answer.length < 2))
    ) {
      exception =
        "Para cada pregunta en notificación debe tener al menos dos opciones de respuesta";
      field = "surveys_notification";
    }

    if (
      cdPaymentSurveyData &&
      ((cdPaymentSurveyData.question && !cdPaymentSurveyData.answer) ||
        (cdPaymentSurveyData.question && cdPaymentSurveyData.answer.length < 2))
    ) {
      exception =
        "Para cada pregunta en desembolso debe tener al menos dos opciones de respuesta";
      field = "surveys_payment";
    }

    if (cdPaymentSurveyData && !cdPaymentSurveyData.question) {
      exception =
        "Debe escribir una pregunta y minimo dos respuestas en desembolso";
      field = "surveys_payment";
    }

    if (cdNotificationSurveyData && !cdNotificationSurveyData.question) {
      exception =
        "Debe escribir una pregunta y minimo dos respuestas en notificacion";
      field = "surveys_notification";
    }

    if (!field) return;

    return {
      errors: [{ exception, field }],
      status: 0
    };
  }

  async saveConfigurationStorage() {
    // verify is new or continue
    this.setState({ generalErrors: [] });
    // verify change data for actual step
    if (this.state.cdOriginal) {
      if (
        this.state.step === 1 &&
        this.state.cdOriginal.cdCampaignConfiguration
      ) {
        const originalConfiguration = {
          dueDay: this.state.cdOriginal.cdCampaignConfiguration.dueDay,
          finishDate: moment(
            this.state.cdOriginal.cdCampaignConfiguration.finishDate
          ).format("Y-MM-DD"),
          legalizationForm: this.state.cdOriginal.cdCampaignConfiguration
            .legalizationForm,
          name: this.state.cdOriginal.cdCampaignConfiguration.name,
          nameDestination: this.state.cdOriginal.cdCampaignConfiguration
            .nameDestination,
          nameGuarantee: this.state.cdOriginal.cdCampaignConfiguration
            .nameGuarantee,
          startDate: moment(
            this.state.cdOriginal.cdCampaignConfiguration.startDate
          ).format("Y-MM-DD")
        };

        const newConfiguration = {
          dueDay: this.state.cdCampaignConfiguration.dueDay,
          finishDate: this.state.cdCampaignConfiguration.finishDate,
          legalizationForm: this.state.cdCampaignConfiguration.legalizationForm,
          name: this.state.cdCampaignConfiguration.name,
          nameDestination: this.state.cdCampaignConfiguration.nameDestination,
          nameGuarantee: this.state.cdCampaignConfiguration.nameGuarantee,
          startDate: this.state.cdCampaignConfiguration.startDate
        };

        if (isEqual(originalConfiguration, newConfiguration))
          return { status: 1 };
      }

      if (
        this.state.step === 2 &&
        this.state.cdOriginal.cdFiltersCampaign &&
        isEqual(
          this.state.cdFiltersCampaign,
          this.state.cdOriginal.cdFiltersCampaign
        )
      ) {
        return { status: 1 };
      }

      if (
        this.state.step === 3 &&
        this.state.cdOriginal.cdSmsNotification &&
        isEqual(
          this.state.cdSmsNotification,
          this.state.cdOriginal.cdSmsNotification
        )
      ) {
        return { status: 1 };
      }

      if (
        this.state.step === 4 &&
        this.state.cdOriginal.cdEmailNotification &&
        isEqual(
          this.state.cdEmailNotification,
          this.state.cdOriginal.cdEmailNotification
        )
      ) {
        return { status: 1 };
      }

      if (
        this.state.step === 5 &&
        this.state.cdOriginal.cdNotificationSurvey &&
        this.state.cdOriginal.cdPaymentSurvey &&
        isEqual(
          this.state.cdNotificationSurvey,
          this.state.cdOriginal.cdNotificationSurvey
        ) &&
        isEqual(
          this.state.cdPaymentSurvey,
          this.state.cdOriginal.cdPaymentSurvey
        )
      ) {
        return { status: 1 };
      }

      if (
        this.state.step === 6 &&
        this.state.cdOriginal.cdCampaignConfiguration
      ) {
        const originalConfiguration = {
          applyQueryCentralRisk: this.state.cdOriginal.cdCampaignConfiguration
            .applyQueryCentralRisk,
          applyUpdateData: this.state.cdOriginal.cdCampaignConfiguration
            .applyUpdateData,
          projectedAmount: this.state.cdOriginal.cdCampaignConfiguration
            .projectedAmount,
          projectedCustomer: this.state.cdOriginal.cdCampaignConfiguration
            .projectedCustomer,
          targetAmount: this.state.cdOriginal.cdCampaignConfiguration
            .targetAmount,
          targetCustomer: this.state.cdOriginal.cdCampaignConfiguration
            .targetCustomer
        };

        const newConfiguration = {
          applyQueryCentralRisk: this.state.cdOriginal.cdCampaignConfiguration
            .applyQueryCentralRisk,
          applyUpdateData: this.state.cdCampaignConfiguration.applyUpdateData,
          projectedAmount: this.state.cdOriginal.cdCampaignConfiguration
            .projectedAmount,
          projectedCustomer: this.state.cdOriginal.cdCampaignConfiguration
            .projectedCustomer,
          targetAmount: this.state.cdOriginal.cdCampaignConfiguration
            .targetAmount,
          targetCustomer: this.state.cdOriginal.cdCampaignConfiguration
            .targetCustomer
        };

        if (isEqual(originalConfiguration, newConfiguration))
          return { status: 1 };
      }
    }

    let idCampaign = this.state.idCampaign;
    let validations;
    // cdCampaignConfiguration
    const cdCampaignConfigurationData = this.state.cdCampaignConfiguration;
    // validate if current step
    if (this.state.step === 1)
      validations = this.validationsGeneralData(cdCampaignConfigurationData);

    // cdFiltersCampaign
    const cdFiltersCampaignData = this.state.cdFiltersCampaign || [];
    if (this.state.step === 2)
      validations = this.validationsSegmentation(cdFiltersCampaignData);

    // cdSmsNotification
    const cdSmsNotificationData = this.state.cdSmsNotification || {};

    // cdEmailNotification
    const cdEmailNotificationData = this.state.cdEmailNotification || {};

    // cdNotificationSurvey & cdPaymentSurvey
    const cdNotificationSurveyData = this.state.cdNotificationSurvey || {};
    const cdPaymentSurveyData = this.state.cdPaymentSurvey || {};
    if (this.state.step === 5)
      validations = this.validationsSurveys(
        cdNotificationSurveyData,
        cdPaymentSurveyData
      );

    if (validations) return validations;

    return this.campaignService
      .saveConfigurationCampaign(idCampaign, {
        cdCampaignConfiguration:
          Object.keys(cdCampaignConfigurationData).length > 0
            ? cdCampaignConfigurationData
            : undefined,
        cdEmailNotification:
          Object.keys(cdEmailNotificationData).length > 0
            ? cdEmailNotificationData
            : undefined,
        cdFiltersCampaign:
          cdFiltersCampaignData.length > 0 ? cdFiltersCampaignData : undefined,
        cdNotificationSurvey:
          Object.keys(cdNotificationSurveyData).length > 0
            ? cdNotificationSurveyData
            : undefined,
        cdPaymentSurvey:
          Object.keys(cdPaymentSurveyData).length > 0
            ? cdPaymentSurveyData
            : undefined,
        cdSmsNotification:
          Object.keys(cdSmsNotificationData).length > 0
            ? cdSmsNotificationData
            : undefined
      })
      .then(response => {
        if (!response.result) {
          return { errors: response.cdExceptions, status: 0 };
        }
        // show notification
        this.setState({ showToast: true });
        // hide notification
        this.setState({ showToast: false });

        this.setState({
          idCampaign: response.object.campaignId,
          statusCampaign: response.object.status
        });

        this.setState({
          cdOriginal: response.object,
          idCampaign: response.object.campaignId
        });

        return { status: 1 };
      })
      .catch(err => {
        return { errors: [{ exception: err.toString() }], status: 0 };
      });
  }

  getStepForField = field => {
    const fieldsGeneralData = [
      "applyQueryCentralRisk",
      "applyUpdateData",
      "creationDate",
      "dueDay",
      "finishDate",
      "guarantee",
      "legalizationForm",
      "loanDestination",
      "loanType",
      "name",
      "nameDestination",
      "nameGuarantee",
      "projectedAmount",
      "projectedCustomer",
      "startDate",
      "targetAmount",
      "targetCustomer",
      "totalCustomersFilter"
    ];

    if (fieldsGeneralData.indexOf(field) > -1) this.setState({ step: 1 });
  };

  nextStep = async () => {
    const { step } = this.state;

    if (this.state.modification) {
      // save info for step
      this.setState({ errors: {}, loading: true });
      const resultSave = await this.saveConfigurationStorage();
      if (resultSave.status === 0) {
        let objectErrors = {};
        resultSave.errors.forEach(error => {
          if (error.field) {
            this.getStepForField(camelize(error.field));
            objectErrors[camelize(error.field)] = error.exception;
          }
        });
        this.setState({ errors: objectErrors });
        this.setState({ loading: false });
        return;
      }
    }

    this.setState({
      step: step + 1
    });

    this.setState({ loading: false });
  };

  prevStep = () => {
    const { step } = this.state;

    this.setState({
      step: step - 1
    });
  };

  initSearchCustomers = async () => {
    // save finish information
    const resultSave = await this.saveConfigurationStorage();
    if (resultSave.status === 0) {
      let tempErrors = [];
      resultSave.errors.forEach(error => tempErrors.push(error.exception));
      this.setState({ generalErrors: tempErrors });
      return;
    }

    this.setState({ modalSuccess: true, step: 1 });
  };

  handleChange = input => event => {
    this.setState({ [input]: event.target.value });
  };

  closeModalSuccess = async () => await this.setState({ modalSuccess: false });

  initFilterCampaign = async () => {
    const resultSave = await this.campaignService.queueFilterCampaign(
      this.state.idCampaign
    );
    await this.closeModalSuccess();

    if (resultSave.status === 0) {
      let tempErrors = [];
      resultSave.errors.forEach(error => tempErrors.push(error.exception));
      this.setState({ generalErrors: tempErrors });
      return;
    }

    this.props.history.push("/campaigns");
  };

  getStep = async step => {
    // save info for step
    if (this.state.modification) {
      const saveStatus = await this.saveStep();

      if (!saveStatus) return;
    }

    this.setState({ step });
  };

  changeValuesCd = (typeObjectName, key, value) => {
    let copyCdObject = Object.assign(this.state[typeObjectName] || {}, {});
    copyCdObject[key] = value;
    this.setState({ [typeObjectName]: copyCdObject });
  };

  changeObjectCd = (typeObjectName, objectCd) => {
    this.setState({ [typeObjectName]: objectCd });
    if (!isEqual(this.state[typeObjectName], objectCd)) {
      this.onChangeinformation();
    }
  };

  youCanSearchCustomers = () => {
    if (
      (this.state.cdCampaignConfiguration &&
        this.state.cdEmailNotification &&
        this.state.cdFiltersCampaign &&
        this.state.cdNotificationSurvey &&
        this.state.cdPaymentSurvey &&
        this.state.cdSmsNotification &&
        this.state.statusCampaign === 0) ||
      this.state.statusCampaign === 1 ||
      this.state.statusCampaign === 3
    ) {
      return true;
    } else {
      return false;
    }
  };

  saveAndClose = async () => {
    if (!this.state.modification && this.state.statusCampaign < 3)
      return this.props.history.push("/campaigns");

    // save info for step
    const saveStatus = await this.saveStep();

    if (saveStatus) return this.props.history.push("/campaigns");
  };

  saveStep = async () => {
    // save info for step
    this.setState({ errors: {}, loading: true });
    const resultSave = await this.saveConfigurationStorage();
    this.setState({ loading: false });

    if (resultSave.status === 0) {
      let objectErrors = {};
      resultSave.errors.forEach(error => {
        if (error.field) {
          this.getStepForField(camelize(error.field));
          objectErrors[camelize(error.field)] = error.exception;
        }
      });
      this.setState({ errors: objectErrors });
      return false;
    } else {
      return true;
    }
  };

  onChangeinformation = (informationChange = true) =>
    this.setState({ informationChange });

  launchCampaign = async () => {
    let exception, field;
    this.setState({ errors: {} });

    if (this.state.cdCampaignConfiguration.projectedAmount <= 0) {
      exception = "La meta proyectada debe ser mas de cero";
      field = "preview";
    }

    if (this.state.cdCampaignConfiguration.projectedCustomer <= 0) {
      exception = "Los clientes proyectados deben ser mas de cero";
      field = "preview";
    }

    if (field) {
      this.closeModalConfirmLauch();
      return this.setState({ errors: { exception, field } });
    }
    // validations preview lauchd
    const resultLauch = await this.campaignService.queueLaunchCampaign(
      this.state.cdCampaignConfiguration.applyQueryCentralRisk,
      this.state.cdCampaignConfiguration.applyUpdateData,
      this.state.idCampaign,
      this.state.cdCampaignConfiguration.projectedCustomer,
      this.state.cdCampaignConfiguration.projectedAmount,
      this.state.cdCampaignConfiguration.targetAmount,
      this.state.cdCampaignConfiguration.targetCustomer
    );
    var tempErrorList = [];

    if (resultLauch.cdExceptions && resultLauch.cdExceptions.length > 0) {
      resultLauch.cdExceptions.forEach(error => {
        if (error.field) {
          tempErrorList.push(error.exception);
        }
      });

      this.setState({ errorsPreview: tempErrorList });
    } else {
      this.props.history.push("/campaigns");
    }
  };

  onChangeService = service => {
    this.campaignService = service;
    if (!this.state.loadInitial) {
      this.loadCampaign();
      this.setState({ loadInitial: true });
    }
  };

  closeModalConfirmLauch = () => this.setState({ modalConfirmLauch: false });
  comfirmLaunchCampaign = () => this.setState({ modalConfirmLauch: true });

  render() {
    const {
      step,
      loading,
      modalSuccess,
      modification,
      statusCampaign,
      loadingData,
      generalErrors,
      notificationText
    } = this.state;

    if (loadingData) return <p>Cargando campaña...</p>;

    return (
      <div className="container">
        <ToastProvider>
          <NotificationPopPup
            showToast={this.state.showToast}
            text={notificationText}
          />
        </ToastProvider>
        <TokenService
          onChangeService={this.onChangeService}
          onGeneralConfiguration={this.onGeneralConfiguration}
        />
        <Modal open={modalSuccess} size="mini" onClose={this.closeModalSuccess}>
          <Modal.Header className="bg-primary">
            <i className="fa fa-trash-o"></i> Confirmaci&oacute;n
          </Modal.Header>
          <Modal.Content className="campaign-new__modal-success">
            <h3>
              <i className="fa fa-check-square-o"></i> Configuraci&oacute;n
              existosa
            </h3>
            <p>
              Ahora puedes comenzar la búsqueda de clientes. Estas seguro de
              iniciar la búsqueda?
            </p>
          </Modal.Content>
          <Modal.Actions>
            <button
              className="btn btn-sm btn-secondary"
              onClick={this.closeModalSuccess}
            >
              No
            </button>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => this.initFilterCampaign()}
            >
              <i className="fa fa-check"></i> Si
            </button>
          </Modal.Actions>
        </Modal>

        {/* confirmation launch campaign */}
        <Modal
          open={this.state.modalConfirmLauch}
          size="mini"
          onClose={this.closeModalConfirmLauch}
        >
          <Modal.Header className="bg-primary">
            <i className="fa fa-trash-o"></i> Confirmaci&oacute;n
          </Modal.Header>
          <Modal.Content className="campaign-new__modal-success">
            <h3>
              <i className="fa fa-check-square-o"></i> Configuraci&oacute;n
              existosa
            </h3>
            <p>Esta seguro de lanzar la campaña?</p>
          </Modal.Content>
          <Modal.Actions>
            <button
              className="btn btn-sm btn-secondary"
              onClick={this.closeModalConfirmLauch}
            >
              No
            </button>
            <button
              className="btn btn-sm btn-primary"
              onClick={this.launchCampaign}
            >
              <i className="fa fa-check"></i> Si
            </button>
          </Modal.Actions>
        </Modal>

        <Step.Group
          attached="top"
          size="mini"
          className="campaign-new__step-group"
        >
          <Step
            active={step === 1}
            completed={step > 1}
            onClick={() => this.getStep(1)}
          >
            Datos Generales
          </Step>
          <Step
            active={step === 2}
            completed={step > 2}
            onClick={() => this.getStep(2)}
          >
            Segmentación
          </Step>
          <Step
            active={step === 3}
            completed={step > 3}
            onClick={() => this.getStep(3)}
          >
            Notificación SMS
          </Step>
          <Step
            active={step === 4}
            completed={step > 4}
            onClick={() => this.getStep(4)}
          >
            Notificación Email
          </Step>
          <Step
            active={step === 5}
            completed={step > 5}
            onClick={() => this.getStep(5)}
          >
            Encuestas
          </Step>
          {statusCampaign > 2 ? (
            <Step
              active={step === 6}
              completed={step > 6}
              onClick={() => this.getStep(6)}
            >
              Previsualización
            </Step>
          ) : null}
        </Step.Group>
        {!modification ? (
          <Message attached="bottom" warning>
            <Icon name="warning sign" />
            Esta campaña no es modificable.&nbsp;
            {statusCampaign === 3
              ? "solo puede hacer cambios en la pestaña previsualización."
              : "los cambios que haga no tendran efectos."}
          </Message>
        ) : null}

        {generalErrors && generalErrors.length > 0 ? (
          <Message
            attached="bottom"
            error
            list={generalErrors}
            header="Resuelva los siguientes errores"
          />
        ) : null}

        <Segment.Group>
          <Segment className="campaign-new__segment">
            {step === 1 ? (
              <GeneralData
                errors={this.state.errors}
                modification={modification}
                cdCampaignConfiguration={this.state.cdCampaignConfiguration}
                onChangeValuesObject={this.changeObjectCd}
              />
            ) : null}
            {step === 2 ? (
              <Segmentation
                errors={this.state.errors}
                modification={modification}
                cdFiltersCampaign={this.state.cdFiltersCampaign || []}
                onChangeValuesObject={this.changeObjectCd}
              />
            ) : null}
            {step === 3 ? (
              <SMSNotification
                errors={this.state.errors}
                modification={modification}
                cdSmsNotification={this.state.cdSmsNotification || {}}
                onChangeValuesObject={this.changeObjectCd}
              />
            ) : null}
            {step === 4 ? (
              <EmailNotification
                errors={this.state.errors}
                modification={modification}
                cdEmailNotification={this.state.cdEmailNotification || {}}
                onChangeValuesObject={this.changeObjectCd}
              />
            ) : null}
            {step === 5 ? (
              <Surveys
                errors={this.state.errors}
                modification={modification}
                cdNotificationSurvey={this.state.cdNotificationSurvey || {}}
                cdPaymentSurvey={this.state.cdPaymentSurvey || {}}
                onChangeValuesObject={this.changeObjectCd}
              />
            ) : null}
            {step === 6 ? (
              <Preview
                errors={this.state.errors}
                modification={modification}
                campaignId={this.state.idCampaign}
                cdCampaignConfiguration={
                  this.state.cdCampaignConfiguration || {}
                }
                onChangeValuesObject={this.changeObjectCd}
                errorsPreview={this.state.errorsPreview}
              />
            ) : null}
          </Segment>
          <Segment className="campaign-new__segment-actions">
            <div className="row">
              <div className="col-12 col-md-4">
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    disabled={step <= 1 || loading}
                    onClick={() => this.prevStep()}
                    className="btn btn-primary btn-icon-text"
                  >
                    <i className="mdi mdi-chevron-left"></i>
                    Anterior
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-icon-text"
                    disabled={
                      step === 6 ||
                      (step === 5 && statusCampaign < 2) ||
                      loading
                    }
                    onClick={() => this.nextStep()}
                  >
                    Siguiente
                    <i className="mdi mdi-chevron-right"></i>
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-4">
                {this.youCanSearchCustomers() ? (
                  <button
                    disabled={loading}
                    onClick={() => this.initSearchCustomers()}
                    type="button"
                    className="btn btn-success"
                  >
                    Iniciar búsqueda de clientes
                  </button>
                ) : null}
                &nbsp;&nbsp;
                {step === 6 && statusCampaign === 3 ? (
                  <button
                    disabled={loading}
                    onClick={this.comfirmLaunchCampaign}
                    type="button"
                    className="btn btn-success btn-icon-text"
                  >
                    <i className="mdi mdi-airplane"></i>
                    Lanzar
                  </button>
                ) : null}
              </div>
              <div className="col-12 col-md-3">
                <div className="campaign-new__container-actions">
                  <button
                    disabled={statusCampaign > 3 || step === 6}
                    onClick={this.saveAndClose}
                    type="button"
                    className="btn btn-secondary"
                  >
                    Guardar y Salir
                  </button>
                  &nbsp;&nbsp;
                  <NavLink to="/campaigns" className="btn btn-danger">
                    Salir
                  </NavLink>
                </div>
              </div>
            </div>
          </Segment>
        </Segment.Group>
      </div>
    );
  }
}

const GeneralData = ({
  cdCampaignConfiguration,
  modification,
  errors,
  onChangeValuesObject
}) => {
  const typeObjectName = "cdCampaignConfiguration";
  const [creationDate, setCreationDate] = useState(new Date());
  const { configurationService } = useAuth();

  const [loanDestination, setLoanDestination] = useState("");
  const [loanType, setLoanType] = useState("");
  const [dueDays, setDueDays] = useState([]);

  const [projectedAmount, setProjectedAmount] = useState(0);
  const [projectedCustomer, setProjectedCustomer] = useState(0);
  const [targetAmount, setTargetAmount] = useState(0);
  const [targetCustomer, setTargetCustomer] = useState(0);

  useEffect(() => {
    if (!configurationService) return;

    const loadConfigurationCampaign = async () => {
      const companyConfiguration = await configurationService.getConfiguration();

      if (!cdCampaignConfiguration && nameDestination === "")
        setNameDestination(
          companyConfiguration.object.generalConfiguration.nameDestination
        );

      if (!cdCampaignConfiguration && loanDestination === "")
        setLoanDestination(
          companyConfiguration.object.generalConfiguration.loanDestination
        );

      if (!cdCampaignConfiguration && loanType === "")
        setLoanType(companyConfiguration.object.generalConfiguration.loanType);

      if (companyConfiguration) {
        const tempDueDays = companyConfiguration.object.generalConfiguration.dueDay.map(
          item => {
            return { key: item, text: item, value: item };
          }
        );

        setDueDays(tempDueDays);
      }
    };

    loadConfigurationCampaign();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configurationService]);

  useEffect(() => {
    const cdCampaignConfigurationDataSource = cdCampaignConfiguration || {};

    if (cdCampaignConfigurationDataSource.finishDate) {
      setFinishDate(
        moment(cdCampaignConfigurationDataSource.finishDate).format("Y-MM-DD")
      );
    }

    if (cdCampaignConfigurationDataSource.legalizationForm) {
      setLegalizationForm(cdCampaignConfigurationDataSource.legalizationForm);
    }

    if (cdCampaignConfigurationDataSource.name) {
      setName(cdCampaignConfigurationDataSource.name);
    }

    if (cdCampaignConfigurationDataSource.nameDestination) {
      setNameDestination(cdCampaignConfigurationDataSource.nameDestination);
    }

    if (cdCampaignConfigurationDataSource.startDate) {
      setStartDate(
        moment(cdCampaignConfigurationDataSource.startDate).format("Y-MM-DD")
      );
    }

    if (cdCampaignConfigurationDataSource.loanDestination) {
      setLoanDestination(cdCampaignConfigurationDataSource.loanDestination);
    }

    if (cdCampaignConfigurationDataSource.loanType) {
      setLoanType(cdCampaignConfigurationDataSource.loanType);
    }

    if (cdCampaignConfigurationDataSource.creationDate)
      setCreationDate(cdCampaignConfigurationDataSource.creationDate);

    if (cdCampaignConfigurationDataSource.projectedAmount)
      setProjectedAmount(cdCampaignConfigurationDataSource.projectedAmount);

    if (cdCampaignConfigurationDataSource.projectedCustomer)
      setProjectedCustomer(cdCampaignConfigurationDataSource.projectedCustomer);

    if (cdCampaignConfigurationDataSource.targetAmount)
      setTargetAmount(cdCampaignConfigurationDataSource.targetAmount);

    if (cdCampaignConfigurationDataSource.targetCustomer)
      setTargetCustomer(cdCampaignConfigurationDataSource.targetCustomer);

    if (cdCampaignConfigurationDataSource.dueDay)
      setDueDay(cdCampaignConfigurationDataSource.dueDay);
  }, [cdCampaignConfiguration]);

  const [errorsInput, setErrorsInput] = useState({});

  const setErrorKey = useCallback(
    (key, text) => {
      const errorsInputTemp = Object.assign(errorsInput, {});
      errorsInputTemp[key] = text;
      setErrorsInput({ ...errorsInputTemp });
    },
    [errorsInput]
  );

  const [readOnly, setReadOnly] = useState(false);
  useEffect(() => {
    setReadOnly(modification === false);
  }, [modification]);

  const [nameDestination, setNameDestination] = useState("");

  const [name, setName] = useState("");
  const onChangeName = useCallback((_, newValue) => setName(newValue.value), [
    setName
  ]);

  const [startDate, setStartDate] = useState("");
  const [finishDate, setFinishDate] = useState("");

  const onChangeFinishDate = useCallback(
    (_, newValue) => {
      setErrorKey("finishDate", undefined);
      setFinishDate(newValue.value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setFinishDate, startDate]
  );

  const onChangeStartDate = useCallback(
    (_, newValue) => {
      if (finishDate && finishDate < newValue.value) {
        setErrorKey(
          "startDate",
          "La fecha de inicio no puede ser mayor a la fecha de finalización"
        );
        setStartDate("");
        return;
      }
      setErrorKey("startDate", undefined);
      setStartDate(newValue.value);
    },
    [finishDate, setErrorKey]
  );

  const [legalizationForm, setLegalizationForm] = useState(0);

  const [dueDay, setDueDay] = useState([]);
  const onChangeDueDay = useCallback(
    (_, newValue) => setDueDay(newValue.value),
    []
  );

  const updateValues = () => {
    let cdCampaignConfigurationTempData = {
      applyQueryCentralRisk: false,
      applyUpdateData: false,
      creationDate,
      dueDay,
      finishDate,
      guarantee: 999,
      legalizationForm,
      loanDestination,
      loanType,
      name,
      nameDestination,
      projectedAmount,
      projectedCustomer,
      startDate,
      targetAmount,
      targetCustomer
    };

    onChangeValuesObject(typeObjectName, cdCampaignConfigurationTempData);
  };

  useEffect(() => {
    updateValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameDestination, name, legalizationForm, onChangeValuesObject]);

  return (
    <Form>
      <Form.Group widths="equal">
        <Form.Input
          value={name}
          fluid
          label="Nombre campaña"
          placeholder="Nombre campaña"
          onChange={onChangeName}
          readOnly={readOnly}
          error={errors.name}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Input
          value={loanType}
          fluid
          label="Línea"
          placeholder="Línea"
          readOnly
          error={errors.loanType}
        />

        <Form.Input
          value={`${loanDestination}-${nameDestination}`}
          fluid
          label="Destino"
          placeholder="Destino"
          readOnly
          error={errors.nameDestination}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Input
          value={startDate}
          fluid
          label="Fecha inicio"
          placeholder="Fecha inicio"
          type="date"
          error={errors.startDate || errorsInput.startDate}
          onChange={onChangeStartDate}
          readOnly={readOnly}
          onBlur={() => (!readOnly ? updateValues() : null)}
        />
        <Form.Input
          value={finishDate}
          fluid
          label="Fecha finalización"
          placeholder="Fecha finalización"
          type="date"
          error={errors.finishDate || errorsInput.finishDate}
          onChange={onChangeFinishDate}
          readOnly={readOnly}
          onBlur={ev => {
            if (startDate > ev.target.value) {
              setErrorKey(
                "finishDate",
                "La fecha final no puede ser inferior a la fecha inicial"
              );
              setFinishDate("");
              return;
            } else if (!readOnly) {
              updateValues();
            }
          }}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Select
          fluid
          label="Días de corte"
          multiple
          options={dueDays}
          value={dueDay}
          disabled={readOnly}
          onChange={onChangeDueDay}
          onBlur={() => {
            updateValues();
          }}
          error={errors.dueDay}
        />
      </Form.Group>
    </Form>
  );
};

GeneralData.defaultProps = {
  errors: {}
};

export const NotificationPopPup = ({ showToast, text }) => {
  const { addToast } = useToasts();

  useEffect(() => {
    if (showToast) {
      addToast(text || "Configuración guardada", {
        appearance: "success",
        autoDismiss: true
      });
    }
  }, [addToast, showToast, text]);

  return null;
};

const TokenService = ({ onChangeService }) => {
  const { campaignService } = useAuth();

  useEffect(() => {
    if (!campaignService) return;
    onChangeService(campaignService);
  }, [campaignService, onChangeService]);

  return null;
};
